import React from 'react'
import { SearchBox } from '@mapbox/search-js-react'

const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN

const DEFAULT_THEME = {
    variables: {
        fontFamily: 'system-ui, sans-serif',
        borderRadius: '6px',
    },
}

const AddressAutoCompleteInput = ({ onLocationChange, placeholder = '', value = '', theme = DEFAULT_THEME }) => {
    const handleRetrieve = (event) => {
        const feature = event?.features?.[0]

        if (!feature) return

        const props = feature.properties
        const coords = feature.geometry?.coordinates

        onLocationChange?.({
            location: props.name + ', ' + props.full_address,
            latitude: coords?.[1],
            longitude: coords?.[0],
        })
    }

    return (
        <div className="event-details-editor-input">
            <SearchBox
                accessToken={MAPBOX_TOKEN}
                onRetrieve={handleRetrieve}
                options={{
                    types: 'poi,address,place',
                    autocomplete: true,
                }}
                placeholder={placeholder}
                value={value}
                theme={theme}
            />
        </div>
    )
}

export default AddressAutoCompleteInput

